AFRAME.registerComponent('rounded-triangle', {
    schema: {
        vertex2: {type: 'vec2'},
        vertex3: {type: 'vec2'},
        radius: {type: 'number', default: 0.05}
    },

    init: function () {
        this.drawTriangle();
    },

    update: function () {
        this.drawTriangle();
    },

    drawTriangle: function () {
        const r = this.data.radius;
        const pos = this.el.object3D.position;

        const v1 = new THREE.Vector2(0, 0);
        const v2 = new THREE.Vector2(this.data.vertex2.x, this.data.vertex2.y);
        const v3 = new THREE.Vector2(this.data.vertex3.x, this.data.vertex3.y);
        const points = [v1, v2, v3];

        const shape = new THREE.Shape();

        function roundCorner(prev, current, next, radius) {
            const dirPrev = new THREE.Vector2().subVectors(prev, current).normalize();
            const dirNext = new THREE.Vector2().subVectors(next, current).normalize();

            const angle = Math.acos(dirPrev.dot(dirNext));
            const distance = radius / Math.tan(angle / 2);

            const p1 = new THREE.Vector2().addVectors(current, dirPrev.multiplyScalar(distance));
            const p2 = new THREE.Vector2().addVectors(current, dirNext.multiplyScalar(distance));

            return [p1, p2];
        }

        for (let i = 0; i < 3; i++) {
            const current = points[i];
            const next = points[(i + 1) % 3];
            const prev = points[(i + 2) % 3];

            const [p1, p2] = roundCorner(prev, current, next, r);

            if (i === 0) shape.moveTo(p1.x, p1.y);
            else shape.lineTo(p1.x, p1.y);

            shape.quadraticCurveTo(current.x, current.y, p2.x, p2.y);
        }

        shape.closePath();

        const geometry = new THREE.ShapeGeometry(shape);

        if (this.el.getObject3D('mesh')) {
            this.el.getObject3D('mesh').geometry.dispose();
            this.el.getObject3D('mesh').geometry = geometry;
        } else {
            this.el.setObject3D('mesh', new THREE.Mesh(geometry, new THREE.MeshStandardMaterial()));
        }
    }
});
